import type { CommunityGroup } from '@communities/community-groups/domain';
import { GET_COMMUNITY_GROUP } from '@communities/community-groups/graphql';
import { getApolloClient } from '@core/apollo/client';
import type { LoaderFunctionArgs } from 'react-router-dom';

interface CommunityGroupLoaderData {
  communityGroup: CommunityGroup;
}

/**
 * Loader for community group routes
 * Fetches community group data before rendering the page
 */
export async function communityGroupLoader({ params }: LoaderFunctionArgs): Promise<CommunityGroupLoaderData> {
  const client = getApolloClient();

  const { data } = await client.query<{ communityGroup: CommunityGroup }>({
    query: GET_COMMUNITY_GROUP,
    variables: { id: params.groupId },
    fetchPolicy: 'cache-first',
  });

  return { communityGroup: data.communityGroup };
}
